export default __webpack_public_path__ + "static/media/project_shot_east_douglas_3.b714f5dc.jpg";